import { observer } from "mobx-react";
import React, { FC } from "react";
import {
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";

import { ApiKeySettingItem } from "../../../../services/apiService";
import { formatInstant } from "../../../helpers/dataHelper";

interface ApiKeysTableProps {
  apiKeys: ApiKeySettingItem[];
  onManage: (apiKeyId: string) => void;
}

const ApiKeysTable: FC<ApiKeysTableProps> = observer(
  ({ apiKeys, onManage }) => {
    const theme = useTheme();

    return (
      <TableContainer
        sx={{ border: `1px solid ${theme.palette.divider}`, borderRadius: 2 }}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Key</TableCell>
              <TableCell>Tenants</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Last used</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {apiKeys.map((apiKey) => (
              <TableRow key={apiKey.id}>
                <TableCell sx={{ fontFamily: "monospace" }}>
                  {apiKey.prefix}••••••••
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {apiKey.tenants.join(", ") || "-"}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    label={apiKey.status}
                    size="small"
                    color={apiKey.status === "active" ? "success" : "default"}
                    sx={{
                      "& .MuiChip-label": {
                        fontSize: "12px",
                        textTransform: "uppercase",
                      },
                    }}
                  />
                </TableCell>
                <TableCell>{formatInstant(apiKey.last_used)}</TableCell>
                <TableCell align="right">
                  <Button
                    onClick={() => onManage(apiKey.id)}
                    variant="outlined"
                    size="small"
                  >
                    Manage
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  },
);

export default ApiKeysTable;
